import * as React from 'react';
import { observer, inject } from 'mobx-react';
import ReactResponsiveSelect from 'react-responsive-select';
import { SubscriptionList } from '../../models/SubscriptionList';
import { getNoBrand } from '../../index';
//css
const subscrDropDownStyle = require('./subscriptiondropdown.css');

// caret icon
const caretIcon = (
  <svg className="caret-icon" x="0px" y="0px" width="11.848px" height="6.338px" viewBox="351.584 2118.292 11.848 6.338">
    <g><path d="M363.311,2118.414c-0.164-0.163-0.429-0.163-0.592,0l-5.205,5.216l-5.215-5.216c-0.163-0.163-0.429-0.163-0.592,0s-0.163,0.429,0,0.592l5.501,5.501c0.082,0.082,0.184,0.123,0.296,0.123c0.103,0,0.215-0.041,0.296-0.123l5.501-5.501C363.474,2118.843,363.474,2118.577,363.311,2118.414L363.311,2118.414z" /></g>
  </svg>
);


interface Props {
  subscriptionList: typeof SubscriptionList.Type;
}

@observer
export default class SubscriptionDropDown extends React.Component<{ subscriptionList: typeof SubscriptionList.Type }> {

  //onchange function
  handleSubscriptionChange = newValue => this.props.subscriptionList.setSelectedSubscription(newValue.value);

  render() {
  
    const noBrand = getNoBrand();
    // Fill option list
    let options: { text: string, value: string, markup: JSX.Element }[] = [];
    this.props.subscriptionList.items.map((entry, index) =>
      options.push({ text: noBrand ? ('Din mobil - ' + entry.number) : (entry.name + ' - ' + entry.number), value: entry.number, markup: <span>{noBrand ? ('Din mobil') : (entry.name)} - {entry.number}</span> }),
    );


    return (

      <div>
        <ReactResponsiveSelect
          caretIcon={options.length > 1 ? caretIcon : null}
          name="subscriptionselect"
          options={options}
          disabled={options.length === 1 ? true : false}
          selectedValue={this.props.subscriptionList.selectedSubscriptionNumber}
          onChange={this.handleSubscriptionChange}
        />
      </div>
    );
  }
}





// WEBPACK FOOTER //
// ./src/components/subscriptiondropdown/SubscriptionDropDown.tsx